import {
  Box,
  Collapse,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TableCell,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FindInPageOutlined, Info, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ID_CABO } from "src/components/componentes/types";
import { VALOR_MULTIPLO_CABO } from "src/components/projetos/constants"
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store"
import { modalComponentesDetalhesData$, servicoInformationModalIsOpenedStore$ } from "src/store/vendas/projetos/store"
import theme from "src/theme/light"
import { ItemSolucaoMobile } from "./itemSolucaoMobile"

const useStyles = makeStyles({
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 16px 8px 16px'
  },
  boxNomeItem: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'start',
    fontSize: "12px",
  },
  headerInfo: {
    color: "#f59e0b",
    fontSize: "12px"
  },
  textoInfo: {
    color: "#6a7282",
    fontSize: "10px",
    paddingLeft: "5px"
  },
  infoRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  boxQuantidadeDados: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space_between",
    alignItems: "center",
    width: "100%",
  },
  boxQuantidade: {
    width: "55%",
    marginLeft: "-25px",
    display: "flex",
  },
  boxDados: {
    width: "20%",
  },
  boxDropdown: {
    width: "30%"
  }, 
})

const DadosTecnicosCellMobile = ({ componente }: { componente: { componente_id: number | null | undefined } }) => {
  return (
    <Box display={"flex"} alignItems="center" justifyContent={"center"}>
      <IconButton
        onClick={e => {
          e.stopPropagation();
          if (componente?.componente_id) {
            modalComponentesDetalhesData$.next(componente.componente_id)
          }
        }}
        size="large">
          <FindInPageOutlined htmlColor="black" />
      </IconButton>
    </Box>
  );
}

interface ModulosMobileProps {
  handleChangeModulo?: (moduloId: number) => void
}

export const ModulosMobile = ({handleChangeModulo}: ModulosMobileProps) => {
  const { modulos, modulo_selecionado, acessorios, estruturas_calculadas, resultado_calculos, valor_servico_pis_cofins } = useProjetosOffGridStore(store => store.state.data)
  const { changeValue: changeStoreValue, syncFileiras, addSolucaoCalculada } = useProjetosOffGridStore(store => store.actions)
  const permissoes = PermissionUtil.getPermissions();
  const [collapseOpened, setCollapseOpened] = useState(true)
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [alturaCollapse, setAlturaCollapse] = useState<string>("0px")

  const temPermissaoCodigoComponente = useMemo(()=>{
      return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)
  },[permissoes])
  const classes = useStyles();
  const nomeComponente = temPermissaoCodigoComponente ? `${modulo_selecionado?.componente_id} - ${modulo_selecionado?.nome}` : modulo_selecionado?.nome;

  const notSelectedModulos = useMemo(() => {
    return (modulos || []).filter(item => item.componente_id !== modulo_selecionado?.componente_id)
  }, [modulo_selecionado?.componente_id, modulos])
  
  useEffect(() => {
    if (contentRef.current) {
      const altura = contentRef.current.clientHeight;
      setAlturaCollapse(`${altura}px`);
    }
  }, []);

  return (<>
    <Collapse key={'key'} in={collapseOpened} collapsedSize={alturaCollapse}>
        <div ref={contentRef} className={classes.itemContainer}>
            <Box textAlign="left" className={classes.boxNomeItem}>
                {/* nome e codigo*/}
                <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={modulo_selecionado?.componente_id || ''}
                    name="radio-buttons-group"
                    onChange={(e: any) => {}}
                    >
                    <FormControlLabel disabled value={modulo_selecionado?.componente_id} control={<Radio style={{color: "green"}}/>} label="" />
                </RadioGroup>
                <Typography>{nomeComponente}</Typography>
            </Box>
            <Box textAlign="left" className={classes.infoRow}>
            {/* informações */}
            <Typography className={classes.headerInfo}>Informações: </Typography>
            <Typography className={classes.textoInfo}>{modulo_selecionado?.descricao}</Typography>
            </Box>
            <Box className={classes.boxQuantidadeDados}>
            {/*quantidade e detalhes*/}
            <Box className={classes.boxQuantidade}>
                <InputQuantidade value={modulo_selecionado?.quantidade || 0} highlightField={false} onChange={() => {}} disabled={true} />
            </Box>
            <Box className={classes.boxDropdown}>
                {notSelectedModulos.length > 0 && (
                    <>
                        {collapseOpened ? <KeyboardArrowUp onClick={() => setCollapseOpened(old => !old)}/> : <KeyboardArrowDown onClick={() => setCollapseOpened(old => !old)}/> }
                    </>
                )}
            </Box>
            <Box className={classes.boxDados}>
                <DadosTecnicosCellMobile componente={{ componente_id: modulo_selecionado?.componente_id || null }} />
            </Box>
            </Box>
            <Divider style={{marginTop: "10px", marginBottom: "5px"}}/>
        </div>
        {notSelectedModulos.map(item => (
            <>
                <ItemSolucaoMobile item={item} tipo_componente={"modulos"} disabledQuantidade={true} handleChangeModulo={(moduloId: number)=>{
                    if(handleChangeModulo){
                        handleChangeModulo(moduloId)
                    }
                }}/>
            </>
        ))}
    </Collapse>
  </>
  )
}
